module.exports = __webpack_public_path__ + "static/media/icon-tms-internal-note.c3a5b9a4.svg";